import theme from '@ifca-root/react-component/src/assets/theme';
import { smallTitle } from '@ifca-root/react-component/src/helpers/Global/ContractGlobalVar';
import { Button, Snackbar } from '@material-ui/core';
import React from 'react';

interface AppUpdateSnackbarProps {
  open: boolean;
  updating: boolean;
  onRefresh: () => void;
  onLater: () => void;
}

// Non-blocking prompt shown when a newer build is waiting. Presentational only.
export const AppUpdateSnackbar = ({
  open,
  updating,
  onRefresh,
  onLater,
}: AppUpdateSnackbarProps) => (
  <Snackbar
    open={open}
    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
    message={
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        <span>{`A new version of ${smallTitle.PRODUCT} is available.`}</span>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <Button
            size="small"
            onClick={onRefresh}
            disabled={updating}
            style={{
              background: '#fff',
              color: '#e07800',
              borderRadius: 6,
              padding: '5px 16px',
              boxShadow: '0 2px 6px rgba(126,74,14,0.25)',
              opacity: updating ? 0.6 : 1,
            }}
          >
            {updating ? 'Updating...' : 'Update'}
          </Button>
          <Button
            color="inherit"
            size="small"
            style={{ opacity: 0.85 }}
            onClick={onLater}
            disabled={updating}
          >
            Later
          </Button>
        </div>
      </div>
    }
    ContentProps={{
      style: {
        background: `linear-gradient(100deg, ${theme.palette.primary.dark}, ${theme.palette.primary.main})`,
        color: theme.palette.primary.contrastText,
        border: '1px solid rgba(255,255,255,0.30)',
        borderRadius: 12,
        boxShadow: '0 10px 30px -8px rgba(126,74,14,0.35)',
      },
    }}
  />
);
